export default __webpack_public_path__ + "static/media/arrowUpDeposit.e631c8be.svg";